import { Box, styled } from '@mui/joy';
import { SxProps, Theme } from '@mui/joy/styles/types';

export const OptionWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
});

export const getArrowIconStyle = (theme: Theme) => ({
  paddingRight: '4px',
  color: theme.palette.neutral[600],
  fontWeight: 500,
});

export const taxonomyPathStyle = {
  maxWidth: '100px',
  paddingRight: '4px',
};

export const getTaxonomyStyle = (theme: Theme): SxProps => ({
  color: theme.palette.neutral[800],
});
